import { createTextComponent } from './createTextComponent';

export const Body = createTextComponent({
  styleAs: 'body',
  tag: 'div',
});
